import axios from "../../axiosDod.js";
const getDodTasks = async ({ commit }, data) => {
  const params = { limit: Number.MAX_SAFE_INTEGER };
  const { search, filters } = data;
  if (search) {
    params.search = search;
  }
  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      params[key] = value;
    }
  }
  const tasks = await axios.get(`tasks`, { params });
  commit("SET_DOD_TASKS", tasks.data);
};

const getDodTasksCategories = async ({ commit }) => {
  const response = await axios.get(`settings`, {
    params: { type: "TASK_CATEGORY" },
  });
  commit("SET_DOD_TASKS_CATEGORIES", response.data);
};

const getDodTasksPriorities = async ({ commit }) => {
  const response = await axios.get(`settings`, {
    params: { type: "PRIORITY_STATUS" },
  });
  commit("SET_DOD_TASKS_PRIORITY", response.data);
};

const removeDodTask = async (_, taskId) => {
  await axios.delete(`tasks/${taskId}`);
};

const updateDodTask = async ({ dispatch }, data) => {
  const {
    taskId,
    status,
    categoryId,
    priorityId,
    dueDate,
    title,
    description,
    employeeId,
    customerId,
    admins
  } = data;
  try {
    await axios.put(`tasks/${taskId}`, {
      title,
      categoryId,
      priorityId,
      customerId,
      employeeId,
      description,
      dueDate,
      status,
      admins

    });
    dispatch("fetchStatusesCounters")
  } catch (error) {
    throw error.response;
  }
};

const addDodTask = async ({ dispatch }, data) => {
  const {
    title,
    categoryId,
    priorityId,
    customerId,
    employeeId,
    admins,
    description,
    dueDate,
    status,
  } = data;
  try {
    await axios.post(`tasks`, {
      title,
      categoryId,
      priorityId,
      customerId,
      employeeId,
      admins,
      description,
      dueDate,
      status,
    });
    dispatch("fetchStatusesCounters")
  } catch (error) {
    throw error.response;
  }
};

const fetchDodCustomerTasks = async ({ commit }, customerId) => {
  const params = { limit: Number.MAX_SAFE_INTEGER, search: customerId };
  const response = await axios.get(`tasks`, { params })
  commit("SET_DOD_CUSTOMER_TASKS", response.data)
}

const fetchDodEmployeeTasks = async ({ commit }, employeeId) => {
  const params = { limit: Number.MAX_SAFE_INTEGER, search: employeeId };
  const response = await axios.get(`tasks`, { params })
  commit("SET_DOD_EMPLOYEE_TASKS", response.data)
}

export default {
  getDodTasks,
  getDodTasksCategories,
  removeDodTask,
  updateDodTask,
  getDodTasksPriorities,
  addDodTask,
  fetchDodCustomerTasks,
  fetchDodEmployeeTasks
};
